import React, { Component }  from "react";
import { withSearch } from "@elastic/react-search-ui";
import i18n from '../i18n';
import { withTranslation, Trans } from 'react-i18next';
import ResetButton from './ResetButton';


const styles = theme => ({
  
});

class SelectedFiltersComp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lang: this.props.lang,
      logged: this.props.logged,
      family_list: this.props.family_list,
      family: this.props.family,
      family_filters: this.props.family_filters,
      label_list: this.props.label_list,
      config: this.props.config/*,
      filters: this.props.filters, 
      removeFilter: this.props.removeFilter, 
      t: this.props.t*/
    };    
    this.onShowFilter = this.props.onShowFilter;
  }
  

  render() {
  const { lang, logged, family_list, family, config, family_filters, label_list, sub_filters, /*filters, removeFilter, t */} = this.state;
    const {filters, removeFilter, t } = this.props;

    return (
    
        <ul className="row">
          <li className="filter-hide-btn col-12 col-sm-4 col-md-3 col-xl-2">        
            <button className="btn gray-btn w-100" onClick={() => this.onShowFilter()}><Trans>Show filters</Trans></button>                                       
          </li>
          <li className="filter-hide-btn col-12 col-sm-4 col-md-3 col-xl-2">
            <ResetButton></ResetButton>
          </li>
          <li className="filter-title-main col-12 col-sm-4 col-md-3 col-xl-2">
            <div className="filter-title"><Trans>Selected Filters</Trans></div>                                
          </li>
    
            {Object.keys(filters).length > 0 ? (
            Object.keys(filters).map(key =>
              {   

                return filters[key]?.values?.map(key2 => {
                  return (                                    
                    <li className="btn col-12 col-sm-4 col-md-3 col-xl-2" key={key2}>
                      
                      <button className="btnKey"  onClick={() => removeFilter(filters[key].field,key2)}>
                        {/*t(filters[key].field)}{(key2!='true'?":"+key2:"")*/}
                        {/*<span className={(key2!='true'?"btnKey1":"")}>*/}
                        <span className="btnKey1">
                        {(Object.hasOwnProperty.call(label_list, filters[key]?.field)?label_list[filters[key].field]:t(filters[key]?.field))}
                        </span>
                        <span className="btnKey2">
                        {(filters[key]?.field=='common'?t(key2):key2)}
                        </span>
                        <div className="close-icon">
                          <img src="/img/svgs/close.svg" className="normal-img" alt="close-icon" />
                          <img src="/img/svgs/close-h.svg" className="hover-img" alt="close-icon" />
                        </div>
                      </button>
                      
                    </li>                                    
                  ) 
                });                                     
              }
            )) : (
              <li>
                <Trans>No filters available</Trans>
              </li>
            )}   
        </ul>
      );
  }
}
  


export default withSearch(({ filters, removeFilter }) => ({
  filters,
  removeFilter
}))(withTranslation()(SelectedFiltersComp));